import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from '@app/_components/_shared/shared.service';
import { OccMap } from './occ-map';

@Injectable({ providedIn: 'root' })
export class OccMapService {

	statuses: any = [
		{ value: '0', name: 'Active' },
		{ value: '2', name: 'Suspended' },
		{ value: '1', name: 'Canceled' }
	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'occMaps';

	add(occMap: OccMap): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(occMap));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`, occMap).pipe();
	}

	update(occMap: OccMap): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`, occMap).pipe();
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/${developmentId}`).pipe();
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`).pipe();
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`, { params: params }).pipe();

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/${id}`).pipe();
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/${id}/audit`).pipe();
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
